import React from "react";
import { Box, Typography } from "@mui/material";
import ExperienceImg1 from "../assests/experience1.avif";
import ExperienceImg2 from "../assests/experience2.avif";
import ExperienceImg3 from "../assests/experience3.avif";
import { useMediaQuery, useTheme } from "@mui/material";

const GrowBusiness = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));

    const styles = {
        container: {
            flex: 1
        },
    };

    return (
        <Box sx={styles.container}>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: isMobile ? 5 : 10 }}>
                <Typography fontWeight="bold" style={{ width: isMobile ? '100%' : '45%', textAlign: 'center', padding: '0px', fontSize: isMobile ? '30px' : '35px', fontWeight: 'bold' }} >
                    Grow Your Business
                </Typography>
                <Typography variant="body1" style={{ width: isMobile ? '100%' : '30%', textAlign: 'center', marginTop: 5, fontSize: isMobile ? '30px' : '34px', color: '#FFC107' }}>
                    In 3 Simple Steps
                </Typography>
            </Box>


            <Box style={{ width: isMobile ? '100%' : '95%', margin: '0px auto', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center' }}>
                <Box style={{ width: isMobile ? '90%' : '32%', margin: isSmall ? '10px auto' : '20px auto', display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isMobile ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                        }}
                    >
                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={ExperienceImg1} style={{ width: 100 }} ></img>
                        </Box>
                        <h3>STEP 1: Schedule Your FREE Audit</h3>
                        <div style={{ lineHeight: '2' }}>
                            Our goal with this call is simple, to understand your business better and to equip you with real-world strategies which will help you grow your business.
                        </div>
                    </Box>
                </Box>
                <Box style={{ width: isMobile ? '90%' : '32%', margin: isSmall ? '10px auto' : '20px auto', display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isMobile ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                        }}
                    >
                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={ExperienceImg2} style={{ width: 100 }} ></img>
                        </Box>
                        <h3>STEP 2: Get Your 90 Days Growth Roadmap</h3>
                        <div style={{ lineHeight: '2' }}>
                            No shiny objects and no unrealistic promises here. We show you a 90 days realistic roadmap keeping in mind how to get the highest ROAS and get higher repeat buyer %.
                        </div>
                    </Box>
                </Box>

                <Box style={{ width: isMobile ? '90%' : '32%', margin: isSmall ? '10px auto' : '20px auto', display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isMobile ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                        }}
                    >
                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={ExperienceImg3} style={{ width: 100 }} ></img>
                        </Box>
                        <h3>STEP 3: Implement the Strategies and… Boom</h3>
                        <div style={{ lineHeight: '2' }}>
                            At the end of the call, you will walk away with a proven strategy that's custom-made to help you grow your business.
                        </div>
                    </Box>
                </Box>
            </Box>


        </Box>
    );
};

export default GrowBusiness;
